<template>
  <div>
    <Medicaid v-if="step === 'medicaid'"/>
    <ExtraHelp v-else-if="step === 'extra-help'"/>
    <BankAndInvestment v-else-if="step === 'bank-and-investment'"/>
    <HouseholdIncome v-else-if="step === 'household-income'"/>
    <PeopleInHousehold v-else-if="step === 'people-in-household'"/>
    <Final v-else-if="step === 'final'"/>
    <Start v-else/>
  </div>
</template>

<script>
  import Start from '@/components/landing/Start'
  import Medicaid from '@/components/landing/Medicaid'
  import ExtraHelp from '@/components/landing/ExtraHelp'
  import BankAndInvestment from '@/components/landing/BankAndInvestment'
  import HouseholdIncome from '@/components/landing/HouseholdIncome'
  import PeopleInHousehold from '@/components/landing/PeopleInHousehold'
  import Final from '@/components/landing/Final'

  export default {
    name: 'Landing',
    components: {
      Start,
      Medicaid,
      ExtraHelp,
      BankAndInvestment,
      HouseholdIncome,
      PeopleInHousehold,
      Final,
    },
    data() {
      return {
        step: 1,
      }
    },
    mounted() {
      this.$data.step = this.$store.getters['getStep']();
      this.watchers = [
        this.$store.watch(this.$store.getters['getStep'], newVal => {
          this.step = newVal;
        }),
      ];
    },
  }
</script>
